import { _ } from "../../../../core/polyglot/polyglot.js";
import { formatFullWithNoDecimalsNorCurrency } from "../../../../core/helpers/currency-formatting-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import DoughnutChartWidget from "../../../../core/DoughnutChartWidget.js";

/**
 *`AgedAccountsDoughnutChartWidget` displays an AgedAccountsSummary
 * as a DoughnutWidget. The legend is the AgedAccountsSummaryTableWidget.
 *
 * @param {AgedAccountsSummary} summary - The summary model used to render the chart.
 * @param {string[]} colors - The colors needed for rendering each group. Its length must
 * be the same as the summary groups.
 * @param {string} [textTotal] - The text labeling the total inside the doughnut.
 * @param {func} [mouseOverCallback] - Optional callback to execute when the mouse pass over
 * an item segment. Takes the item as parameter.
 */
export default class AgedAccountsDoughnutChartWidget extends Widget {
	constructor({
		summary,
		colors,
		textTotal = _("Total"),
		mouseOverCallback = () => {},
	}) {
		super(...arguments);

		this._summary = summary;
		this._colors = colors;
		this._textTotal = textTotal;
		const items = this._makeItems(summary.getGroups());
		this._mouseOverCallback = mouseOverCallback;

		const total = items.reduce((r, x) => x.magnitude + r, 0);

		this._doughnutChart = new DoughnutChartWidget({
			items,
			radius: 115,
			doughnutWidth: 30,
			title: this._textTotal,
			subtitle: formatFullWithNoDecimalsNorCurrency(total),
			getTitleWhenHighlighted: this._labelRenderer.bind(this),
			getSubtitleWhenHighlighted: this._valueRenderer.bind(this),
			mouseOverCallback: this._mouseOverCallback,
		});
	}

	renderContentOn(html) {
		html.render(this._doughnutChart);
	}

	highlightGroup(group) {
		this._doughnutChart.setHighlightedValue(group);
	}

	_labelRenderer(group) {
		if (!group) {
			return () => {};
		}

		return group.getLabel();
	}

	_valueRenderer(group) {
		if (!group) {
			return () => {};
		}

		return formatFullWithNoDecimalsNorCurrency(group.getValue());
	}

	_makeItems(groups) {
		return groups.map((group, index) => ({
			magnitude: group.getValue(),
			color: this._colors[index],
			value: group,
		}));
	}
}
